import { AutoMap } from "@automapper/classes"
import { Temporal } from "@js-temporal/polyfill"

export class ConsommableDTO {

    @AutoMap()
    type: number = 0
    @AutoMap()
    numeroLot: string = ''
    @AutoMap()
    expiration: string = ''
}